import { createFileRoute } from '@tanstack/react-router'
import { ProductDetailPage } from '../../../../features/catalog/product-detail-page'
import { productProfileSearchSchema } from '../../../../features/catalog/search'

export const Route = createFileRoute('/_app/products/$productId/')({
  validateSearch: productProfileSearchSchema,
  component: ProductDetailPage,
})
